<template>
  <div v-loading="loading">
    <div class="m-b-20 ovf-hd">
      <div class="fl" v-show="addShow">
        <router-link class="btn-link-large add-btn" to="add">
          <i class="el-icon-plus"></i>&nbsp;&nbsp;添加流程
        </router-link>
        <router-link class="btn-link-large add-btn m-l-10" to="/flowtype/list">分类管理</router-link>
      </div>
			<div class="fl w-300 m-l-30" @keyup.enter="search()">
				<el-input v-model="keywords" placeholder="输入流程名称"></el-input>
			</div>
			<div class="fl m-l-20">
				<el-button type="primary" @click="search">搜索</el-button>
			</div>
      <div class="fr">
        <router-link to="message">
          <el-button type="primary">自动提醒配置</el-button>
        </router-link>
      </div>
    </div>
    <el-table :data="tableData" style="width: 100%" @selection-change="selectItem">
      <el-table-column type="selection" width="50">
      </el-table-column>
      <el-table-column label="名称" prop="name" width="200">
      </el-table-column>
      <el-table-column label="分类" prop="type_name" width="200">
      </el-table-column>
      <el-table-column label="最后更新时间" prop="update_time">
        <template scope="scope">
          <div>
            {{ scope.row.update_time | parseTime }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="status">
        <template scope="scope">
          <div :class="{'bad': scope.row.status === 0}">
           {{ scope.row.status | parseStatus }}
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="数据管理员" prop="manage_name" width="200">
      </el-table-column> -->
      <el-table-column label="操作" width="350">
        <template scope="scope">
          <div>
            <span v-show="editShow">
              <router-link :to="{ name: 'flowEdit', params: { id: scope.row.id }}" class="btn-link edit-btn m-r-5">
            编辑
              </router-link>
            </span>
           <span v-show="designShow">
              <router-link :to="{ name: 'flowDesign', params: { id: scope.row.id }}" class="btn-link el-button el-button--default m-r-5">
            配置流程
              </router-link>
            </span>
            <el-button size="small" type="primary" @click="copyFlow(scope.row.id)" :loading="copyLoading">复制</el-button>
            <!-- <span>
               <router-link :to="{ name: 'flowCaseList', params: { id: scope.row.id }}" class="btn-link edit-btn m-r-5">
            查看实例
               </router-link>
             </span>
            <span class="btn-link edit-btn m-r-5" @click="showCreateDialog(scope.row.id)">发起流程</span> -->
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pos-rel p-t-20">
      <btnGroup @toggleCallback='handleBtnResult' :selectedData="multipleSelection" :type="'bpm/flows'"></btnGroup>
      <div class="block pages">
        <el-pagination @current-change="handleCurrentChange" layout="prev, pager, next" :page-size="limit" :current-page="currentPage"
          :total="dataCount">
          </el-pagination>
      </div>
    </div>
    <el-dialog title="流程发起提示" v-model="dialogVisible" size="tiny">
      <span>是否发起一个流程？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="createFlow">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import btnGroup from '../../Common/normal/btn-group.vue'
  import http from '../../../assets/js/http'

  export default {
    data() {
      return {
        tableData: [],
        dataCount: null,
        currentPage: null,
        keywords: '',
        status: '',
        multipleSelection: [],
        deleteFlowDialog: false,
        statusOption: [
          {
            label: '启用',
            value: 1
          },
          {
            label: '禁用',
            value: 0
          }
        ],
        loading: false,
        limit: 15,
        curId: null, // 当前发起的流程id
        dialogVisible: false,
        copyLoading: false, // 是否正在复制表单
        returnParam: null // 返回参数
      }
    },
    filters: {
      parseTime(item) {
        return moment.unix(item).format('YYYY-MM-DD')
      },
      parseStatus(status) {
        if (status === 0) {
          return '禁用'
        }
        return '启用'
      }
    },
    methods: {
      // 监听按钮子组件的触发事件
      handleBtnResult(param) {
        _g.updateMenus()
      },
      search() {
        router.push({ name: 'flowList', query: { keywords: this.keywords, page: 1, status: this.status }})
      },
      selectItem(val) {
        this.multipleSelection = val
      },
      handleCurrentChange(page) {
        router.push({ name: 'flowList', query: { keywords: this.keywords, page: page, status: this.status }})
      },
      showCreateDialog(id) {
        this.dialogVisible = true
        this.curId = id
      },
      createFlow() {
        this.apiPost(`bpm/flows/${this.curId}/cases`).then((res) => {
          if (res.code == 200) {
            router.push({ name: 'flowForm', params: { id: this.curId }, query: { case_id: res.data.caseId, node_id: res.data.startNodeId }})
          } else {
            _g.dealError(this, res)
          }
          this.dialogVisible = false
        })
      },
      copyFlow(flow_id) {
        let postData = {
          flow_id: flow_id,
          num_prefix: ''
        }
        this.apiPost(`bpm/flows/copy`,postData).then((res) => {
          if (res.code === 200) {
            _g.toastMsg(this, 'success', '复制流程成功')
            // 刷新页面
            this.getAllFlow()
            return
          }
          _g.toastMsg(this, 'error', res.error)
        })
      },
      getAllFlow() {
        this.loading = true
        let postData = {
          params: {
            keywords: this.keywords,
            limit: this.limit,
            page: this.currentPage,
            status: this.status,
            isFilter: 0
          }
        }
        this.apiGet('bpm/flows', postData).then((res) => {
          this.loading = false
          if (res.code == 200) {
            this.tableData = res.data.list
            this.dataCount = res.data.dataCount
          } else {
            _g.dealError(this, res)
          }
        })
      },
      getCurrentPage() {
        let data = this.$route.query
        if (data) {
          if (data.page) {
            this.currentPage = parseInt(data.page)
          } else {
            this.currentPage = 1
          }
        }
      },
      getKeywords() {
        let data = this.$route.query
        if (data) {
          if (data.keywords) {
            this.keywords = data.keywords
          } else {
            this.keywords = ''
          }
        }
      },
      init() {
        this.getKeywords()
        this.getCurrentPage()
        this.getAllFlow()
      }
    },
    created() {
      this.init()
    },
    computed: {
      addShow() {
        return _g.getHasRule('')
      },
      editShow() {
        return _g.getHasRule('')
      },
      designShow() {
        return _g.getHasRule('')
      },
      deleteShow() {
        return _g.getHasRule('')
      }
    },
    watch: {
      '$route'(to, from) {               // 监听路由改变
        this.init()
      }
    },
    components: {
      btnGroup
    },
    mixins: [http]
  }

</script>
<style>
  .bad {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// list.vue?8d3cfa52